module.exports = __webpack_public_path__ + "img/faculdad-del-ciencias-cor.3b967735.png";